// extracted by mini-css-extract-plugin
export default {"table":"table--k1scE","hrow":"hrow--k1scE","row":"row--k1scE","header":"header--k1scE","subhead":"subhead--k1scE","cell":"cell--k1scE","centered":"centered--k1scE"};